import SingleLoanViewModeratorForm from "components/tenders/singleLoan/SingleLoanViewModeratorForm";
import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useParams, useNavigate } from 'react-router';
import Cookies from 'universal-cookie';

function SingleLoanViewModeratorFormPage2(props: any) {
    const params = useParams();
    const navigate = useNavigate();
    const cookies = new Cookies();
    useEffect(() => {
        if(cookies.get('bank_form_tender_id') !== params?.tender_req_id){
            navigate("/pankki/");
        }
    },[])
    useEffect(()=>{
        caches.keys().then((names) => {
            names.forEach((name) => {
              caches.delete(name);
            });
        });
    },[props])
    return (
        <Container className="pt-2 px-0">
            <SingleLoanViewModeratorForm {...{...props,...useParams()}} type={`bank`}/>
        </Container>
    );
}

export default SingleLoanViewModeratorFormPage2;